import React, { useState, useEffect, useRef } from 'react'
import "./../styles/crossword.css";
import "./../styles/crossword2.css";
import { Link } from 'react-router-dom'
import GameNav from '../GameNav';



export default function CrossWordThree() {

    const [activeQuestion, setActiveQuestion] = useState(1);
    const [activeStreak, setActiveStreak] = useState([]);
    const [inputValues, setInputValues] = useState([]);
    const [checkAnswersClicked, setCheckAnswersClicked] = useState(false);
    // const rows = 18;
    const rows = 16;
    const cols = 17;
    // const rows = 25;
    // const cols = 14;
    const initialPuzzleState = Array.from({ length: rows }, () => Array.from({ length: cols }, () => null));
    const [puzzle, setPuzzle] = useState(initialPuzzleState);
    const [win, setWin] = useState(false);

    const correctAnswers = [
        'B', 'A', 'S', 'S', 'S', 'A', 'L', 'A', 'W', 'I', 'N', 'G', '-', 'C', 'H', 'O', 'I', 'R', 'F', 'I', 'N', 'A', 'L', 'S', 'E', 'X', 'H', 'I', 'B', 'I', 'T', 'I', 'O', 'S', 'T', 'A', 'G', 'E', 'C', 'R', 'E', 'W', 'O', 'L', 'O', 'I', 'S', 'T', 'C', 'A', 'P', 'E', 'R', 'O', 'N', 'B', 'G', 'B', 'A', 'N', 'D', 'B', 'O', 'A', 'D', 'W', 'Y']




    const resetGame = () => {
        setActiveQuestion(1);
        setPuzzle(initialPuzzleState);
        setInputValues([]);
        setEnteredValues(Array(filledCells.length).fill(null));
        setCheckAnswersClicked(false);
        setWin(false);
    };


    const spaceCells = [
        [8, 9]
    ]

    const filledCells = [

        [0, 12],
        [1, 12],
        [2, 12],
        [3, 12],


        //2 across

        [3, 9],
        [3, 10],
        [3, 11],
        [3, 13],

        // 2 down

        [4, 9],
        [5, 9],
        [6, 9],
        [7, 9],
        [8, 9],  //space cell
        [9, 9],
        [10, 9],
        [11, 9],
        [12, 9],
        [13, 9],


        [5, 16],
        [6, 16],
        [7, 16],
        [8, 16],
        [9, 16],
        [10, 16],


        [6, 0],
        [6, 1],
        [6, 2],
        [6, 3],
        [6, 4],
        [6, 5],
        [6, 6],
        [6, 7],
        [6, 8],



        //5 across
        [8, 4],
        [8, 5],
        [8, 6],
        [8, 7],
        [8, 8],
        [8, 10],
        [8, 11],
        [8, 12],
        [8, 13],


        //5 down
        [9, 4],
        [10, 4],
        [11, 4],
        [12, 4],
        [13, 4],
        [14, 4],


        [10, 8],
        [10, 10],
        [10, 11],
        [10, 12],
        [10, 13],
        [10, 14],
        [10, 15],



        [12, 3],
        [12, 5],


        [12, 14],
        [13, 14],
        [14, 14],
        [15, 14],



        [13, 8],
        [13, 10],
        [13, 11],
        [13, 12],
        [13, 13],
        [13, 15],

    ];


    const [enteredValues, setEnteredValues] = useState(Array(filledCells.length).fill(null));

    useEffect(() => {
        if (activeQuestion === 1) {
            setActiveStreak([
                [0, 12],
                [1, 12],
                [2, 12],
                [3, 12],
            ]);

            setInputValues([
                [''],
                [''],
                [''],
                ['']

            ])
        } else if (activeQuestion === 2) {
            setActiveStreak([
                [3, 9],
                [3, 10],
                [3, 11],
                [3, 12],
                [3, 13],

            ]);

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                ['']


            ])

        } else if (activeQuestion === 3) {
            //2 down
            setActiveStreak([


                [3, 9],
                [4, 9],
                [5, 9],
                [6, 9],
                [7, 9],
                [8, 9],
                [9, 9],
                [10, 9],
                [11, 9],
                [12, 9],
                [13, 9],

            ]);

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                ['']

            ])
        } else if (activeQuestion === 4) {
            setActiveStreak([

                [5, 16],
                [6, 16],
                [7, 16],
                [8, 16],
                [9, 16],
                [10, 16],

            ])

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                [''],
                ['']

            ])

        } else if (activeQuestion === 5) {
            setActiveStreak([

                [6, 0],
                [6, 1],
                [6, 2],
                [6, 3],
                [6, 4],
                [6, 5],
                [6, 6],
                [6, 7],
                [6, 8],
                [6, 9],

            ])

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                ['']

            ])
        } else if (activeQuestion === 6) {
            setActiveStreak([


                [8, 4],
                [8, 5],
                [8, 6],
                [8, 7],
                [8, 8],
                [8, 9],
                [8, 10],
                [8, 11],
                [8, 12],
                [8, 13],

            ])




            setInputValues([
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                ['']



            ])
        } else if (activeQuestion === 7) {
            setActiveStreak([

                [8, 4],
                [9, 4],
                [10, 4],
                [11, 4],
                [12, 4],
                [13, 4],
                [14, 4],


            ])

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                ['']


            ])
        } else if (activeQuestion === 8) {
            setActiveStreak([
                [10, 8],
                [10, 9],
                [10, 10],
                [10, 11],
                [10, 12],
                [10, 13],
                [10, 14],
                [10, 15],
                [10, 16],

            ])

            setInputValues([

                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                ['']

            ])
        } else if (activeQuestion === 9) {
            setActiveStreak([

                [12, 3],
                [12, 4],
                [12, 5],

            ])

            setInputValues([
                [''],
                [''],
                ['']


            ])
        } else if (activeQuestion === 10) {
            setActiveStreak([

                [12, 14],
                [13, 14],
                [14, 14],
                [15, 14],


            ])

            setInputValues([
                [''],
                [''],
                [''],
                [''],


            ])
        } else if (activeQuestion === 11) {
            setActiveStreak([

                [13, 8],
                [13, 9],
                [13, 10],
                [13, 11],
                [13, 12],
                [13, 13],
                [13, 14],
                [13, 15],


            ])

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                ['']


            ])
        }



    }, [activeQuestion]);

    const totalQuestions = 11;

    const handleChange = (index, e) => {
        const newInputValues = [...inputValues];
        newInputValues[index] = e.target.value.toUpperCase();
        setInputValues(newInputValues);
    };


    const handleKeyDown = (index, e) => {
        if (/^[a-zA-Z-]$/.test(e.key)) {
            e.preventDefault();
            const newInputValues = [...inputValues];
            newInputValues[index] = e.key.toUpperCase();
            setInputValues(newInputValues);

            if (index < activeStreak.length - 1) {
                const nextIndex = index + 1;
                document.getElementById(`input-${nextIndex}`).focus();
            }
        } else if (e.key === 'Backspace') {
            e.preventDefault();
            const currentInput = inputValues[index];

            if (currentInput === '') {
                if (index > 0) {
                    const prevIndex = index - 1;
                    document.getElementById(`input-${prevIndex}`).focus();
                }
            } else {
                const newInputValues = [...inputValues];
                newInputValues[index] = '';
                setInputValues(newInputValues);
            }
        }
    };

    const resetInputValues = () => {
        setInputValues(Array(activeStreak.length).fill(''));
    };


    // const checkCompletion = () => {
    //     const isPuzzleComplete = enteredValues.every(value => value !== null);
    //     if (isPuzzleComplete) {
    //         console.log('Puzzle is complete!');
    //         filledCells.forEach(([row, col], index) => {
    //             console.log(`Value at (${row}, ${col}): ${enteredValues[index]}`);
    //         });
    //     }
    // };
    const answerSubmit = () => {
        if (inputValues.every(value => typeof value === 'string' && value.trim() !== '' && value !== null)) {
            const newEnteredValues = [...enteredValues];
            const newPuzzle = puzzle.map(row => [...row]);
            activeStreak.forEach(([row, col], index) => {
                const cellIndex = filledCells.findIndex(([r, c]) => r === row && c === col);
                if (cellIndex !== -1) {
                    newEnteredValues[cellIndex] = inputValues[index];
                    newPuzzle[row] = [...newPuzzle[row]];
                    newPuzzle[row][col] = inputValues[index];
                }
            });
            setEnteredValues(newEnteredValues);
            setPuzzle(newPuzzle);
            nextQuestion();
        } else {
            alert('Please fill in the entire answer before submitting');
        }
    };



    const checkAnswers = (e) => {
        e.preventDefault();
        const isCorrect = enteredValues.every((value, index) => value.toUpperCase() === correctAnswers[index]);
        setCheckAnswersClicked(true);
        if (isCorrect) {
            setWin(true);
        }
    };




    const nextQuestion = () => {
        const newQuestion = (activeQuestion % totalQuestions) + 1;
        setActiveQuestion(newQuestion);
        resetInputValues();
    };

    const prevQuestion = () => {
        const newQuestion = (activeQuestion - 2 + totalQuestions) % totalQuestions + 1;
        setActiveQuestion(newQuestion);
    };



    const grid = Array.from({ length: rows }, () => Array.from({ length: cols }).fill(0));

    filledCells.forEach(([row, col]) => {
        if (row < rows && col < cols) {
            grid[row][col] = 1;
        }
    });



    const gridItems = [];

    const clues = [
        { number: 1, label: 1, start: [0, 12] },
        { number: 2, label: 2, start: [3, 9] },
        { number: 3, label: 2, start: [3, 9] },
        { number: 4, label: 3, start: [5, 16] },
        { number: 5, label: 4, start: [6, 0] },
        { number: 6, label: 5, start: [8, 4] },
        { number: 7, label: 5, start: [8, 4] },
        { number: 8, label: 6, start: [10, 8] },
        { number: 9, label: 7, start: [12, 3] },
        { number: 10, label: 8, start: [12, 14] },
        { number: 11, label: 9, start: [13, 8] },



    ];


    const streakClick = (row, col) => {
        const matchingClues = clues.filter(
            clue => clue.start[0] === row && clue.start[1] === col
        );

        if (matchingClues.length > 0) {
            const currentClue = matchingClues.find(
                clue => clue.number === activeQuestion
            );

            const nextClue = currentClue
                ? matchingClues[(matchingClues.indexOf(currentClue) + 1) % matchingClues.length]
                : matchingClues[0];

            setActiveQuestion(nextClue.number);

        }
    };




    for (let row = 0; row < rows; row++) {
        for (let col = 0; col < cols; col++) {
            // const [row, col] = filledCells[index];
            const isFilled = grid[row] && grid[row][col] === 1;

            const isStartOfClue = clues && activeStreak && clues.some(
                (clue) => clue && clue.start && Array.isArray(clue.start) && clue.start[0] === row && clue.start[1] === col
            );


            const isSpaceCell = spaceCells.some(([spaceRow, spaceCol]) => spaceRow === row && spaceCol === col);

            const cellStyle = {
                border: isFilled ? '1px solid #826A8C' : 'none',
                backgroundColor: isSpaceCell ? '#826A8C' : isFilled ? '#fff' : 'transparent',
                boxSizing: 'border-box',
                position: 'relative'

            };

            const cellContent = (
                <div

                >
                    <span

                        className={`entered-letter ${checkAnswersClicked &&
                            enteredValues.find(
                                (value, index) =>
                                    filledCells[index][0] === row && filledCells[index][1] === col
                            ) === correctAnswers[
                            filledCells.findIndex(
                                (cell) => cell[0] === row && cell[1] === col
                            )
                            ]
                            ? 'correct'
                            : checkAnswersClicked &&
                                enteredValues.find(
                                    (value, index) =>
                                        filledCells[index][0] === row && filledCells[index][1] === col
                                ) !== correctAnswers[
                                filledCells.findIndex(
                                    (cell) => cell[0] === row && cell[1] === col
                                )
                                ]
                                ? 'incorrect'
                                : 'mid-game-letter'

                            }`}
                    >
                        {enteredValues.find((value, index) => filledCells[index][0] === row && filledCells[index][1] === col) || ''}
                    </span>
                    {isStartOfClue && (
                        <div className='clue'>
                            {clues.find(clue => clue && clue.start && clue.start[0] === row && clue.start[1] === col)?.label}
                        </div>
                    )}
                </div>
            );
            // win !== true &&
            gridItems.push(
                <div className={`cell ${activeStreak.length > 0 && activeStreak.some(([r, c]) => r === row && c === col) ? 'active-streak-cell' : ''}`} key={`${row}-${col}`} style={cellStyle}
                    onClick={() => streakClick(row, col)}
                >
                    {cellContent}
                </div>
            );
        }
    }


    return (
        <div className='crossword-main'>
            <GameNav />
            <div className='crossword-container'>
                <div className='crossword-bg'>
                    <img className='cw2img1' src='images/crossword/1-min.png' />

                    <img className='cw2img2' src='images/crossword/6.png' />

                    <img className='cw2img3' src='images/crossword/5.png' />
                    <div id='crossword-grid-3'>
                        {gridItems}
                    </div>

                </div>

            </div>


            {win ? (
                <div className='crossword-win-screen'>


                    <h2>You Win!</h2>

                    <Link to='/'>
                        <button className='nextLevelCWbtn'>Home</button>
                    </Link>


                </div>
            ) : (
                <></>
            )}





            <div className='crossword-control-main' style={{ position: 'relative' }}>
                <div className={`cw-outer ${win ? 'win-blur' : ''}`}>
                    <div className='crossword-control'>

                        <div onClick={prevQuestion} className=' prev-btn questions-btn btn-background-circle-q'>
                            <svg className='arrow-prev-q arrow-q' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114.53 162.9">
                                <path
                                    className='prev svg-btn-q'
                                    d="M217.4,165.87a7.76,7.76,0,0,0,0,12.12l52,41.61,38.68,30.94a12.87,12.87,0,0,0,20.91-10h0a12.88,12.88,0,0,0-4.83-10.05L310.62,219.6,251,171.93l59.6-47.65,13.57-10.85A12.89,12.89,0,0,0,329,103.38h0a12.87,12.87,0,0,0-20.91-10l-38.68,31Z"
                                    transform="translate(-214.49 -90.49)"
                                />
                            </svg>
                        </div>
                        <div className={`question ${activeQuestion === 1 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 1</h4>
                                <img src={process.env.PUBLIC_URL + '/images/down-icon.png'} height='28px'></img>
                            </div>

                            <p>In SATB singing the “B” stands for</p>
                        </div>
                        <div className={`question ${activeQuestion === 2 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 2</h4>
                                <img src={process.env.PUBLIC_URL + '/images/across-icon.png'} width='30px'></img>
                            </div>
                            <p>Show choir snack or Latin dance style</p>
                        </div>
                        <div className={`question ${activeQuestion === 3 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 2</h4>
                                <img src={process.env.PUBLIC_URL + '/images/down-icon.png'} height='28px'></img>
                            </div>
                            <p>Show choir is sometimes called? 2 word term, enter - for space</p>
                        </div>
                        <div className={`question ${activeQuestion === 4 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 3</h4>
                                <img src={process.env.PUBLIC_URL + '/images/down-icon.png'} height='28px'></img>
                            </div>
                            <p>First Place prelim winner advances to the</p>
                        </div>
                        <div className={`question ${activeQuestion === 5 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 4</h4>
                                <img src={process.env.PUBLIC_URL + '/images/across-icon.png'} width='30px'></img>
                            </div>
                            <p>Host show choir performs only in</p>
                        </div>
                        <div className={`question ${activeQuestion === 6 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 5</h4>
                                <img src={process.env.PUBLIC_URL + '/images/across-icon.png'} width='30px'></img>
                            </div>
                            <p>Parents and students who set-up risers and scenery is known as the? 2 word term, enter - for space</p>
                        </div>
                        <div className={`question ${activeQuestion === 7 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 5</h4>
                                <img src={process.env.PUBLIC_URL + '/images/down-icon.png'} height='28px'></img>
                            </div>
                            <p>The show choir’s featured singer</p>
                        </div>
                        <div className={`question ${activeQuestion === 8 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 6</h4>
                                <img src={process.env.PUBLIC_URL + '/images/across-icon.png'} width='30px'></img>
                            </div>
                            <p>Parents who ride show choir bus with students</p>
                        </div>
                        <div className={`question ${activeQuestion === 9 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 7</h4>
                                <img src={process.env.PUBLIC_URL + '/images/across-icon.png'} width='30px'></img>
                            </div>
                            <p>Show choir girls hair must be</p>
                        </div>
                        <div className={`question ${activeQuestion === 10 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 8</h4>
                                <img src={process.env.PUBLIC_URL + '/images/down-icon.png'} height='28px'></img>
                            </div>
                            <p>The backup instrumentalists is the</p>
                        </div>

                        <div className={`question ${activeQuestion === 11 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 9</h4>
                                <img src={process.env.PUBLIC_URL + '/images/across-icon.png'} width='30px'></img>
                            </div>
                            <p>Show choir members hope someday to make it big on</p>
                        </div>

                        <div onClick={nextQuestion} className=' next-btn questions-btn btn-background-circle-q'>
                            <svg className='arrow-next-q arrow-q' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114.53 162.9">
                                <path
                                    className='next svg-btn-q'
                                    d="M326.1,165.87a7.75,7.75,0,0,1,0,12.12l-52,41.61-38.69,30.94a12.86,12.86,0,0,1-20.9-10h0a12.88,12.88,0,0,1,4.83-10.05l13.57-10.85,59.6-47.67-59.6-47.65-13.57-10.85a12.89,12.89,0,0,1-4.83-10.05h0a12.86,12.86,0,0,1,20.9-10l38.69,31Z"
                                    transform="translate(-214.49 -90.49)"
                                />
                            </svg>
                        </div>
                    </div>
                    <form className='question-input'>
                        <div className='input-cells'>
                            {activeStreak.map((cell, index) => {
                                const [row, col] = cell;

                                // Check if this cell is a space cell
                                const isSpaceCell = spaceCells.some(([spaceRow, spaceCol]) => spaceRow === row && spaceCol === col);

                                return (
                                    <input
                                        key={index}
                                        id={`input-${index}`}
                                        className={`question-input-cell ${isSpaceCell ? 'space-input' : ''} ${activeQuestion === 8 ? 'long-question' : ''}`}
                                        value={inputValues[index]}
                                        onChange={(e) => handleChange(index, e)}
                                        onKeyDown={(e) => handleKeyDown(index, e)}
                                        maxLength={1}
                                    />
                                );
                            })}
                        </div>


                        <div className='input-btns'>
                            {inputValues.every(value => typeof value === 'string' && value.trim() !== '' && value !== null) ? (
                                <div className='submit-btn' onClick={answerSubmit}>
                                    Submit
                                </div>
                            ) : (
                                <div className='submit-btn-disabled' onClick={answerSubmit}>
                                    Submit
                                </div>
                            )}



                            <div>
                                {enteredValues.every(value => value !== null || '') ? (
                                    <button className='check-btn' onClick={checkAnswers}>Check</button>
                                ) : (
                                    <button type="button" className='disabled-check-btn'>Check</button>
                                )
                                }

                            </div>
                        </div>
                    </form>


                </div>

            </div>


        </div>
    )
}


